import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OeAppService } from '../../shared/oe-app.service';
import { Store } from '../../shared/store';
import { KeyValueObjectType } from '../../shared/types/key-value-object-type';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';

@Injectable()
export class ImmersionCarouselService extends Store<StudyBundleCourseDto[]> {
  constructor(private http: HttpClient, private oeAppService: OeAppService) {
    super();
  }

  getImmersions(
    courseContentTypes: string[],
    pageIndex: number,
    pageSize: number,
    includedTopics: string[] = [],
    excludedTopics: string[] = [],
    sortBy: string,
    filteredStatuses: string[],
    extraParams?: Array<KeyValueObjectType>
  ): Observable<Array<StudyBundleCourseDto>> {
    const types: string = courseContentTypes.join();
    let params: HttpParams = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filteredStatuses', filteredStatuses.join(','))
      .set('courseContentTypes', types)
      .set('sortBy', sortBy)
      .set('excludedTopics', excludedTopics.join(','))
      .set('includedTopics', includedTopics.join(','))
      .set('contactId', this.oeAppService.getPersonData().contactId);

    if (extraParams) {
      extraParams.forEach(
        (param) => (params = params.set(param.key, param.value))
      );
    }
    return this.http.get<Array<StudyBundleCourseDto>>(
      `${this.oeAppService.courseServiceHost}/v1/courses/immersions`,
      { params }
    );
  }

  isEmpty$(): Observable<boolean> {
    return this.state$.pipe(map((list) => !list || list.length === 0));
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/immersion-carousel/immersion-carousel.service.ts